import React, { useContext } from 'react';
import {
  PageWrapper,
  StyledPageTabBar,
  StyledPaperShadow,
  StyledTabWrapper,
} from '../../components/styled/styles';
import { BackNavigationHeader } from '../../components/styled/back-navigation-header';
import { AppBar, LinearProgress, Tab, Typography } from '@dls/react-core';
import { useMatch, useNavigate, Outlet, useOutletContext } from 'react-router-dom';
import { RoutePaths } from '../../routes/main-routes';
import { getSubject, Subject as SubjectInterface } from '../../api/studykit';
import { StudyPageContext } from '../../App';
import useRequest from '../../api/useRequest';
import { useAuthorization } from '../../context/authorization';

type SubjectContext = {
  subject: SubjectInterface;
};

export const Subject = () => {
  const match = useMatch(`/${RoutePaths.Studies}/:studyId/subjects/:subjectId/:tab`);
  const subjectId = match?.params.subjectId;
  const studyId = match?.params.studyId;
  const { study } = useContext(StudyPageContext);
  const tab = match?.params.tab;
  const navigate = useNavigate();

  const { hasPermission } = useAuthorization();

  const subjectTabs = [
    {
      tab: 'data',
      label: 'Data',
      disabled: !(
        hasPermission('SubjectsData.Read') ||
        hasPermission('SubjectsData.Query') ||
        hasPermission('SubjectsData.Create')
      ),
    },
    // {
    //   tab: 'summary',
    //   label: 'Summary',
    //   disabled: !hasPermission('SubjectsData.Query'),
    // },
    { tab: 'devices', label: 'Devices', disabled: !hasPermission('Devices.Read') },
    { tab: 'details', label: 'Personal details', disabled: !hasPermission('Subjects.Read') },
  ];

  const { data: subject, error } = useRequest(getSubject(studyId!, subjectId!));

  if (error) {
    return (
      <PageWrapper>
        <Typography variant={'h1'}>Something went wrong...</Typography>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <BackNavigationHeader
        navigateTo={`/${RoutePaths.Studies}/${studyId}`}
        title={subject?.name}
        properties={{
          Study: study.name,
          'Start Date': subject?.startDate?.toLocaleString() || 'Missing',
          'End Date': subject?.endDate?.toLocaleString() || 'Missing',
        }}
      />
      <StyledPaperShadow>
        <AppBar position={'static'}>
          <StyledPageTabBar value={tab} className="disabled-tabs">
            {subjectTabs.map((s, i) => (
              <Tab
                value={s.tab}
                style={{ width: `12rem` }}
                key={i}
                label={s.label}
                className="navigation"
                onClick={() => navigate(s.tab)}
                disabled={s.disabled}
              />
            ))}
          </StyledPageTabBar>
        </AppBar>
        <StyledTabWrapper style={{ padding: 0 }}>
          {subject === undefined ? (
            <LinearProgress variant={'indeterminate'} />
          ) : (
            <Outlet context={{ subject }} />
          )}
        </StyledTabWrapper>
      </StyledPaperShadow>
    </PageWrapper>
  );
};

export const useSubjectContext = () => {
  return useOutletContext<SubjectContext>();
};
